import { GUIDE_FILTER_FIELDS, GUIDE_FILTER_GROUPS } from './guidesFilters.js';

const LAYOUTS = {
  modal: {
    gridTwo: 'search-modal__grid search-modal__grid--two',
    gridOne: '',
    group: 'search-modal__group',
    label: 'search-modal__label',
    input: 'search-modal__input',
    singleSpan: '',
  },
  page: {
    gridTwo: 'grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3',
    gridOne: 'grid grid-cols-1 gap-3',
    group: 'space-y-1.5',
    label: 'text-[11px] font-semibold uppercase tracking-[0.08em] text-[rgba(var(--muted),0.82)]',
    input:
      'h-9 w-full rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgb(var(--panel))] px-3 text-sm text-[rgb(var(--fg))] shadow-sm focus:outline-none focus:ring-2 focus:ring-[rgba(var(--ring),0.6)]',
    singleSpan: 'md:col-span-2 lg:col-span-3',
  },
};

function getGroups(fieldKeys) {
  if (!Array.isArray(fieldKeys) || !fieldKeys.length) {
    return GUIDE_FILTER_GROUPS;
  }

  return GUIDE_FILTER_GROUPS.map(group => ({
    ...group,
    fields: group.fields.filter(fieldKey => fieldKeys.includes(fieldKey)),
  })).filter(group => group.fields.length);
}

export default function GuidesFiltersFields({
  formState,
  onChange,
  variant = 'page',
  initialFocusRef,
  fieldKeys,
}) {
  const layout = LAYOUTS[variant] || LAYOUTS.page;
  const groups = getGroups(fieldKeys);

  return (
    <>
      {groups.map((group, groupIndex) => (
        <div key={group.id} className={group.columns === 2 ? layout.gridTwo : layout.gridOne}>
          {group.fields.map((fieldKey, fieldIndex) => {
            const field = GUIDE_FILTER_FIELDS[fieldKey];
            if (!field) {
              return null;
            }
            const isFirst = groupIndex === 0 && fieldIndex === 0;
            const fieldRef = isFirst ? initialFocusRef : undefined;
            const groupClass =
              group.columns === 1 && layout.singleSpan
                ? `${layout.group} ${layout.singleSpan}`
                : layout.group;

            return (
              <div key={field.name} className={groupClass}>
                <span className={layout.label}>{field.label}</span>
                {field.type === 'select' ? (
                  <select
                    ref={fieldRef}
                    className={layout.input}
                    name={field.name}
                    value={formState[field.name] ?? ''}
                    onChange={onChange}
                  >
                    {(field.options || []).map((option) => (
                      <option key={`${field.name}-${option.value || 'blank'}`} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    ref={fieldRef}
                    className={layout.input}
                    type={field.type}
                    name={field.name}
                    value={formState[field.name] ?? ''}
                    onChange={onChange}
                    placeholder={field.placeholder}
                  />
                )}
              </div>
            );
          })}
        </div>
      ))}
    </>
  );
}
